module.exports = __webpack_public_path__ + "img/rocketleague_conference-champs.9ace8d51.jpg";